import React, { FC } from "react";
import { Image as ThemeUIImage, ImageProps } from "theme-ui";

export const ImageCardHorizontal: FC<ImageProps> = (imageProps: ImageProps) => (
  <ThemeUIImage variant="card.horizontal" {...imageProps} />
);
